import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

import { CookieService } from '../services/cookie.service';

const CSRF_HEADER = 'X-CSRF-Token';
const CSRF_COOKIE = 'csrfcookie';

export const csrfInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const cookieService = inject(CookieService);

  const csrfToken = cookieService.getCookie(CSRF_COOKIE);

  const request = csrfToken
    ? req.clone({
        setHeaders: {
          [CSRF_HEADER]: csrfToken,
        },
      })
    : req;

  return next(request);
};
